import * as React from 'react';
import { withLocalize, LocalizeContextProps, Translate } from "react-localize-redux";
import bindAllOfThis from 'src/utils/BindThisHelper';
import { Row, Col } from "antd";
import DialogBox from "src/components/mission/DialogBox";
import { EnhancedProps } from 'src/pages/student/models/props';
import AudioPlayer from "src/components/common/AudioPlayer";
import AudioTranslations from "src/constants/AudioTranslations";

export interface Exploring1Props extends EnhancedProps, LocalizeContextProps {
}

interface Exploring1State {
    translationKey: string;
    translationStep: number;
    translationArray: string[];
}

/**
 * Dialog box with only body text and a next arrow button
 * Contains terrain, star pilot, and star pod
 */
class Exploring1 extends React.Component<Exploring1Props, Exploring1State> {
    constructor(props: Exploring1Props) {
        super(props);
        bindAllOfThis(this, Exploring1.prototype);

        this.state = {
            translationKey: "",
            translationStep: 0,
            translationArray: []
        };
    }

    componentDidMount(): void {
        this.deriveStateFromProps(this.props);
        document.addEventListener("keydown", this.handleKeyPress, false);
    }

    componentWillUnmount() {
        // Remove the event when we change pages
        document.removeEventListener("keydown", this.handleKeyPress, false);
    }

    componentWillReceiveProps(nextProps: Exploring1Props) {
        if (this.props.activeLanguage !== nextProps.activeLanguage ||
            this.props.User.gradeId !== nextProps.User.gradeId ||
            this.props.Mission.current.planetId !== nextProps.Mission.current.planetId) {
            // Update the translation array
            this.deriveStateFromProps(nextProps);
        }
    }

    handleKeyPress(event): void {
        if (event.key === "ArrowRight") {
            if (this.hasNextButton()) {
                this.onNext();
            }
        }
        else if (event.key === "ArrowLeft") {
            if (this.hasBackButton()) {
                this.onBack();
            }
        }
    }

    hasNextButton(): boolean {
        return true;
    }

    hasBackButton(): boolean {
        return this.state.translationStep > 0;
    }

    onNext() {
        // Update the state step first
        let step = this.state.translationStep + 1;
        if (step < this.state.translationArray.length) {
            this.setState({
                translationStep: step
            });
            return;
        }
        this.props.onNext();
    }

    onBack() {
        // Update the state step first (go backwards)
        let step = this.state.translationStep - 1;
        if (step >= 0) {
            this.setState({
                translationStep: step
            });
            return;
        }
        this.props.onBack();
    }

    deriveStateFromProps(newProps: Exploring1Props) {
        let translatedKey = "%game%.Intro.PreVid"
            .replace("%game%", newProps.currentGame.name)
            .replace("%planet%", newProps.currentPlanet.name)
            .replace("%grade%", newProps.currentGrade.name)
            .replace("%gradeNumber%", newProps.currentGrade.shortName);
        let translatedText = newProps.translate(translatedKey).toString();
        let translatedArray = (translatedText || "").split("|").map(x => x.trim());
        let translatedStep = newProps.Mission.currentDirection === "forwards" ? 0 : translatedArray.length - 1;

        this.setState({
            translationKey: translatedKey,
            translationArray: translatedArray,
            translationStep: translatedStep,
        } as Exploring1State);
    }

    renderHeader() {
        if (this.state.translationStep === 0) {
            let headerTranslateKey = "student.exploring.title".replace("%game%", (this.props.currentGame || { name: "" }).name);
            return <h3><Translate id={headerTranslateKey} /></h3>;
        }
        return null;
    }

    render() {
        let planetCode: string = (this.props.currentPlanet || { name: "" }).name.toLowerCase() as string;
        let currentDialog: string = (this.state.translationArray || [""])[this.state.translationStep];

        let terrainClassName = `planet-terrain planet-terrain-${planetCode}`;
        let podClassName = `star-pod star-pod-landed star-pod-${planetCode}-landed`;
        let pilotClassName = `star-pilot star-pilot-${planetCode}`;

        let translationKey = this.state.translationKey;
        // If there are breaks in the audio, load the parted audio instead
        if (this.state.translationArray.length > 1) {
            translationKey = `${translationKey}.part${this.state.translationStep + 1}`;
        }
        let audioTrans = AudioTranslations.FindByKeyAndLanguage(translationKey, this.props.activeLanguage.code);
        this.props.onChangeAudio(audioTrans.url);

        return <div>
            <Row>
                <Col className="dialog-content" xs={{ span: 22, push: 1 }} md={{ span: 16 }} lg={16} xl={14}>
                    <Row>
                        <DialogBox
                            currentGrade={this.props.currentGrade}
                            currentPlanet={this.props.currentPlanet}
                            buttonNextType={this.hasNextButton() ? "arrow" : "none"}
                            buttonBackType={this.hasBackButton() ? "arrow" : "none"}
                            onBack={this.onBack}
                            onNext={this.onNext}>
                            {this.renderHeader()}
                            <p>{currentDialog}</p>
                        </DialogBox>
                    </Row>
                </Col>
            </Row>
            <div className={pilotClassName} />
            <div className={podClassName} />
            <div className={terrainClassName} />
        </div>;
    }
}

export default withLocalize(Exploring1);



// WEBPACK FOOTER //
// ./src/pages/student/scenes/Exploring1.tsx